import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import { useGetTotalQuery } from "../../redux/slice/general/generalStatisca.js";
import { admins, students, employers, teachers } from "../../assetss/task_icons/index.js";

const Card = ({ title, value, balance, img, delay }) => {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  return (
    <div
      data-aos="fade"
      data-aos-delay={delay}
      className="border rounded-xl p-2 bg-white shadow-md  container mx-auto items-center shadow-black/30 grid grid-cols-3 transition-all"
    >
      <div className="col-span-2 flex flex-col gap-2">
        <h3 className="text-lg font-semibold text-black whitespace-nowrap">{title}</h3>
        <p className="text-2xl">{value}</p>
        <p className="text-2xl">{balance}</p>

      </div>
      <div className="max-w-full ml-auto">
        <img src={img} alt="Icon" className="max-w-full" />
      </div>
    </div>
  );
};

// ... (imports)

const Stats = () => {
  const { data, isLoading } = useGetTotalQuery();
  useEffect(() => {
    if (data) {
      const dataString = JSON.stringify(data);
      sessionStorage.setItem('debts', dataString);
    }
  }, [data]);
  return (
    <div className="grid grid-cols-2 container mx-auto md-lg:grid-cols-3 lg:grid-cols-4 gap-2 mt-3 w-full">
      {data?.map((val, index) => (
        <React.Fragment key={index}>
          <Card delay={200} title={"Adminlar"}  value={val.admins ?? 0} img={admins} />
          <Card delay={400} title={"Hodimlar"} value={val.employers ?? 0} img={employers} />
          <Card delay={500} title={"O'quvchilar"} balance={data[0]?.students?.finance?.total_debts.toLocaleString("ru-Ru")}  value={val.students?.count ?? 0} img={students} />
          <Card delay={500} title={"O'qtuvchilar"} value={val.teachers ?? 0} img={teachers} />
        </React.Fragment>
      ))}
    </div>
  );
};

export default Stats;

